module.exports = __webpack_public_path__ + "img/avatar.19ddd1c5.jpg";